import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const InputPhone = ({
  defaultCountry = "in",
  onChange = () => {},
  value,
  required = false,
  className = "",
  onEnterKeyPress = () => {},
  title,
  disabled = false
}) => {
  const inputClasses = [
    "w-full",
    "pl-[60px]",
    "pr-3",
    "h-11",
    "border",
    "rounded-md",
    "font-medium",
    "text-sm",
    "bg-white",
    "border-[#C2C2C2]",
    "focus:border-[#C2C2C2]",
    "hover:border-[#C2C2C2]",
    "outline-none",
    required ? "border-red-500" : "",
    className
  ].join(" ");

  return (
    <div className="w-full flex flex-col gap-1">
      <label className="text-sm font-medium text-gray-700 mb-1">
        {title}{" "}
        {required && (
          <small className="text-red-500 text-xs ml-1">(Required)</small>
        )}
      </label>
      <PhoneInput
        disabled={disabled}
        onEnterKeyPress={onEnterKeyPress}
        country={defaultCountry}
        value={value}
        onChange={onChange}
        inputClass={inputClasses}
        containerClass="w-full"
        buttonClass="!top-1/2 !-translate-y-1/2"
      />
    </div>
  );
};

export default InputPhone;
